<template lang="html">
  <div class="productSlider">
  	<div class="sliderWrapper">
  		<div class="container2">
  			<section class="main-photo">
  				<div v-for="item in items" class="item" v-if="item.img" :style="`background-image: url(${item.img})`">
            <a class="full-screen"  data-fancybox="group" :href="item.img">
              <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0h24v24H0z" fill="none"/>
                  <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/>
              </svg>
            </a>
          </div>
  			</section>
  		</div>
  		<div class="container1">
  			<section class="horizont-slider">
  				<div v-for="item in items" v-if="item.img" class="itm">
  					<img :src="item.img" alt="">
  				</div>
  			</section>
  		</div>

  	</div>
  </div>
</template>

<script>
require('slick-carousel');
require('__scss/slick.scss');
require('__scss/slick-theme.scss');


module.exports = {
	props: {
		dataParams: {
			type: String,
			required: true
		},
		dataStaticParams: {
			type: String,
			required: false
		}
	},

	data () {
		return {
			api_response: {},
			items: []
		}
	},

	computed: {
		componentParams() {
			let str = this.dataParams.replace(/'/g, '"');
			return JSON.parse(str);
		},
		staticParams() {
			let str2 = this.dataStaticParams.replace(/'/g, '"');
			return JSON.parse(str2);
		}
		// items() {
		// 	return this.api_response ? this.api_response.items : [];
		// }
	},

	watch: {
		api_response() {
			this.items = this.api_response.items;
		}
	},

	methods: {

	},

  updated() {
    $(".main-photo").slick({
  		slidesToShow: 1,
  		slidesToScroll: 1,
  		fade: true,
      dots: true,
      arrows: false,
  		asNavFor: '.horizont-slider'
  	});
  	$('.horizont-slider').slick({
  		slidesToShow: 4,
  		slidesToScroll: 1,
  		asNavFor: '.main-photo',
  		dots: false,
  		arrows: false,
  		focusOnSelect: true
  	});
  },

	mounted() {
		if(this.dataStaticParams) {
			this.items = this.staticParams;
			this.locked = false;
		}else{
			let method = this.componentParams.method;
			let url = this.componentParams.url;
			let custom_request = this.componentParams.request;

			let options = {
				responseType: 'json'
			}

			if(method.toLowerCase() == 'post') {
				options.emulateJSON = true;
				this.$http[method](url, custom_request, options).then(success).catch(error);
			}
			else if(method.toLowerCase() == 'get') {
				options.params = custom_request;
				this.$http[method](url, options).then(success).catch(error);
			}

			function success(response) {
				// console.log(response)
				this.api_response = response.body.api_response;
			}

			function error(err) {
				console.log(err);
			}
		}
	}
}
</script>

<style lang="scss">
@import "scss/wanted";
.productSlider{
  margin-bottom: 30px;
  @include l_up{
    height: 520px;
  }
  .sliderWrapper{
    position: relative;
    background-color: white;
    padding: 10px;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-around;
    box-shadow: 0px 1px 4px rgba(242, 242, 242, 4);
    border-radius: 2px;

    @include m_up{
      padding: 20px 20px 40px 20px;
    }
    .full-screen{
      position: absolute;
      top: 0;
      right: 0;
      width: 34px;
      height: 34px;
      border-radius: 100%;
      box-shadow: 0px 3px 4.7px 0.3px rgba(242, 242, 242, 4),0px 1px 4px rgba(242, 242, 242, 4);
      display: flex;
      align-items: center;
      justify-content: center;
      svg{
        fill: #a1a1ac;
      }
    }
    .container1{
      height: 56px;
      min-height: 56px;
      display: none;
      @include m_up{
        display: block;
      }
    }
    .container2{
      width: 100%;
    }
  }
  .horizont-slider{
    width: 300px;
    height: 100%;
    margin: auto;
    display: none;
    @include m_up{
      display: block;
    }
    .slick-slide{
      margin-bottom: 18px;
      .itm{
        width: 56px!important;
        height: 56px;
        min-height: 56px;
        border: 1px solid #d9d9de;
        border-radius: 2px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 80%;
        @include single-transition();
        cursor: pointer;
        display: flex!important;
        *{
          margin: auto;
          max-width: 50px;
          max-height: 50px;
          align-self: center;
        }
        &.video{
          background-size: 100%;
          border-color: transparent;
        }
        &:hover{
          border-color: #006eb6;

        }
      }
      &.slick-current{
        .itm{
          border-color: #006eb6;
          &.video{
            border-color: #006eb6!important;
            background-color: #dd4b39;
          }
        }
      }
    }
  }
  .main-photo{
    .item{
      width: 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      height: 250px;
      @include m_up{
        height: 350px;
      }
      iframe{
        width: 100%;
        height: 100%;
      }
    }
    .slick-arrow{
      /* background-image: url('../img/arr.svg'); */
      box-shadow: none;
      opacity: .7;
      @include single-transition();
      &:before{
        display: none;
      }
      &.slick-next{
        transform: rotate(-90deg);
      }
      &.slick-prev{
        transform: rotate(90deg);
      }
      &:hover{
        opacity: 1;
      }
    }
    .slick-dots{
      @include m_up{
        display: none!important;
      }
      button{
        box-shadow: none;
        border: 1px solid #d9d9de;
        width: 10px;
        height: 10px;
        font-size: 0;
        &:before{
          display: none;
        }
        &:hover{
          background-color: transparent;
          border-color: #006eb6;
        }
      }
      .slick-active{
        button{
          border-color: #006eb6;
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// slickSlider.vue?0ebfd80e